import React from 'react';
import { connect } from 'react-redux';
import { signOut, fetchMenu } from '../../../actions';
import MenuList from './MenuList';
import { Link } from 'react-router-dom';

class Sidebar extends React.Component{
    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
    }

    async componentDidMount(){
        //await this.props.fetchMenu(this.props.account.idRole);
        window.$("#sidebar").mCustomScrollbar({
            theme: "minimal"
            });
            window.$('#sidebarCollapse').on('click', function () {
            window.$('#sidebar, #content').toggleClass('active');
            window.$('.collapse.in').toggleClass('in');
            window.$('a[aria-expanded=true]').attr('aria-expanded', 'false');
        }); 
    }
    
    async handleClick() {
        this.setState({isFetching: true});
        await this.props.signOut();
    }

    render(){
        return (
            <nav id="sidebar">
                <div className="sidebar-header">
                    <div className="text-center">
                        <Link to={`/dashboard`}><img alt="Eduprime Logo" style={{width: "80%"}} src="https://eduprime.co.id/static/images/eduprimkecil.png" /></Link>
                    </div>
                </div>

                <ul className="list-unstyled components">
                    <div className="container">
                        <div className="row" style={{paddingBottom: '20px'}}>
                            <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                                <img alt="user avatar" srcSet="https://s3edubucket.s3-ap-southeast-1.amazonaws.com/images/icons/siswa.jpg" style={{height: '100px', width: 'auto', borderRadius: '50%'}}/>
                            </div>
                            <div className="col-md-12 col-lg-12 col-sm-12 text-center" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                                {this.props.account.namaUser}
                                <br /><button className="btn btn-primary" onClick={this.handleClick}>Log Out</button>
                            </div>
                        </div>
                    </div>
                    {/* {this.props.profil.isPsep === "1" && */}
                        <MenuList account={this.props.account} />
                    {/* } */}
                </ul>
            </nav>
        );
    }

    componentDidUpdate(){
        console.log(this.props);
    }
}

export default connect(null, {signOut, fetchMenu})(Sidebar);